export class AppSettings {
   public static API_ENDPOINT    = 'https://api-live.gharbaar.com/api/';
   //public static API_ENDPOINT    = 'http://192.168.19.20:8000/api/';
   public static IMAGE_URL       = 'https://gharbaar-uploads.s3.ap-south-1.amazonaws.com/uploads/';
   public static IMAGE_URL_TEMP  = 'https://api-live.gharbaar.com/uploads/';
   public static PROJECT_ID      = 1;

   public static blogStatus         = ['Pending', 'Approved'];
   public static verifiedStatuses   = [{'name': 'Pending', 'value': 0}, {'name': 'Approved', 'value': 1}];
   public static leadSources        = ['UAN', 'Zameen', 'Facebook', 'Website', 'Other'];
   public static Interests          = ['5 marla Plot', '8 marla Plot', '10 marla Plot', '1 kanal', '2 kanal', 'Commercial', 'Overseas', 'Not Sure'];
   public static leadStatus         = ['New Lead', 'Call back', 'Not interested', 'Wrong No', 'Appointment', 'Follow Up', 'No response', 'Duplicate', 'Sale', 'PFSOE', 'Visited'];
   public static AppointmentStatus  = ['Appointment', 'Rescheduled', 'No response', 'Call back', 'Visited', 'Sale', 'Not interested', 'PFSOE'];
   public static visitStatus        = ['Visited', 'Sale', 'PFSOE'];
   public static BinStatus          = ['New Lead', 'Call back', 'Not interested', 'Wrong No', 'Appointment', 'Rescheduled', 'Visited', 'Follow Up', 'No response', 'Duplicate', 'Sale', 'PFSOE'];
   public static cities  = [
    {"id": 11, "name" : "Islamabad"},
    {"id": 5,  "name" : "Rawalpindi"}
  ];
  public static maxPriceLabel = { name: 'Any', value: 100000000000 };
  public static searchAreas  = {
    ftsq  : [ 450, 675, 1125, 1800, 2250, 3375, 4500, 6750, 9000, 11250 ],
    yard  : [ 50, 60, 70, 80, 100, 120, 150, 200, 250, 300, 350, 400, 450, 500, 1000, 2000, 4000 ],
    meter : [ 50, 80, 130, 200, 250, 380, 510, 760, 1000, 1300, 1900, 2500, 3800, 5100, 6300, 13000, 19000, 25000, 51000 ],
    marla : [ 2, 3, 5, 8, 10, 15, 20, 30, 40, 50 ],
    kanal : [ 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 15, 20, 30, 50, 100 ]
  };

  public static searchUnits  = [
    { unit: 'ftsq',  name: 'Ft²' },
    // { unit: 'yard',  name: 'Yd²' },
    // { unit: 'meter', name: 'M²' },
    { unit: 'marla', name: 'Marla' },
    { unit: 'kanal', name: 'Kanal' },
  ];

  public static searchPrices    = [ 500000, 1000000, 2000000, 3500000, 5000000, 6500000, 8000000, 10000000, 12500000, 15000000,
    17500000, 20000000, 25000000, 30000000, 40000000, 50000000, 75000000, 100000000,
    250000000, 500000000, 1000000000, 5000000000
  ];

  public static searchTypes  = {
    // HomesIcon: '',
    Homes: [
      // Homes Types
      { name: 'House',              value: 'House',            plural: 'Houses',       pTypeSigular: 'Home', pTypePlural: 'Homes' },
      { name: 'Flat',               value: 'Flat',             plural: 'Flats'          },
      { name: 'Upper Portion',      value: 'Upper Portion',    plural: 'Upper Portions' },
      { name: 'Lower Portion',      value: 'Lower Portion',    plural: 'Lower Portions' },
      { name: 'Farm House',         value: 'Farm House',       plural: 'Farm Houses'    },
      { name: 'Room',               value: 'Room',             plural: 'Rooms'          },
      { name: 'Penthouse',          value: 'Penthouse',        plural: 'Penthouses'     },
    ],

    // PlotsIcon: '',
    Plots: [
      // // Plot Types
      // { name: 'Residential Plot',   value: 'Residential Plot',  plural: 'Residential Plots', pTypeSigular: 'Plot', pTypePlural: 'Plots' },
      // { name: 'Commercial Plot',    value: 'Commercial Plot',   plural: 'Commercial Plots'   },
      // { name: 'Agricultural Land',  value: 'Agricultural Land', plural: 'Agricultural Land'  },
      // { name: 'Industrial Land',    value: 'Industrial Land',   plural: 'Industrial Land'    },
      // { name: 'Plot File',          value: 'Plot File',         plural: 'Plot Files'         },
      // { name: 'Plot Form',          value: 'Plot Form',         plural: 'Plot Forms'         },

      { name: 'Residential Plot',     value: 'Residential Plot',         plural: 'Residential Plots',       pTypeSigular: 'Plot', pTypePlural: 'Plots' },
      { name: 'Residential Plot File',   value: 'Residential Plot File',    plural: 'Residential Plot Files'         },
      { name: 'Residential Plot Form',   value: 'Residential Plot Form',    plural: 'Residential Plot Forms'         },

      { name: 'Commercial Plot',         value: 'Commercial Plot',          plural: 'Commercial Plots'               },
      { name: 'Commercial Plot File',    value: 'Commercial Plot File',     plural: 'Commercial Plot Files'          },
      { name: 'Commercial Plot Form',    value: 'Commercial Plot Form',     plural: 'Commercial Plot Forms'          },

      { name: 'Agricultural Land',       value: 'Agricultural Land',        plural: 'Agricultural Land'              },
      { name: 'Industrial Land',         value: 'Industrial Land',          plural: 'Industrial Land'                },
    ],

    Commercial: [
      // Commercial Types
      { name: 'Office',             value: 'Office',            plural: 'Offices', pTypeSigular: 'Commercial Property', pTypePlural: 'Commercial Properties' },
      { name: 'Shop',               value: 'Shop',              plural: 'Shops'       },
      { name: 'Warehouse',          value: 'Warehouse',         plural: 'Warehouses'  },
      { name: 'Factory',            value: 'Factory',           plural: 'Factories'   },
      { name: 'Building',           value: 'Building',          plural: 'Buildings'   },
      { name: 'Other',              value: 'Other',             plural: 'Other'       }
    ]
  };
}
